import { render } from "./EditUserComponent.vue?vue&type=template&id=6f5ab187"
import script from "./EditUserComponent.vue?vue&type=script&lang=js"
export * from "./EditUserComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__